import { useSettings } from "@/context/SettingsContext";
import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import QRCode from "@/components/QRCode";

export default function Footer() {
  const { settings } = useSettings();
  return (
    <footer
      data-testid="site-footer"
      className="mt-32 border-t border-white/10 bg-black"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <img
              src={settings?.logo_url || "/assets/logo.png"}
              alt=""
              className="h-14 w-14 object-contain"
            />
            <div>
              <div className="font-serif text-2xl text-white">
                {settings?.company_name || "DAS SIMAO AUTO"}
              </div>
              <div className="text-xs tracking-[0.35em] gold uppercase mt-1">
                À votre service
              </div>
            </div>
          </div>
          <p className="mt-6 text-sm text-gray-400 leading-relaxed max-w-sm">
            Convoyage de véhicules premium et service VTC sur-mesure. Nous
            transportons vos automobiles et nos passagers avec le même soin,
            partout en France.
          </p>
        </div>

        <div>
          <div className="text-xs tracking-widest gold uppercase mb-4">
            Contact
          </div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3 text-gray-300">
              <Phone size={16} className="mt-1 gold" />
              <span data-testid="footer-phone">
                {settings?.phone || "06 45 14 29 65"}
              </span>
            </li>
            <li className="flex items-start gap-3 text-gray-300">
              <Mail size={16} className="mt-1 gold shrink-0" />
              <a
                data-testid="footer-email"
                href={`mailto:${settings?.email || "contact.dassimaoauto@gmail.com"}`}
                className="hover:text-white transition-colors text-xs sm:text-sm break-all"
              >
                {settings?.email || "contact.dassimaoauto@gmail.com"}
              </a>
            </li>
            {(settings?.address_line1 || settings?.city) && (
              <li className="flex items-start gap-3 text-gray-300">
                <MapPin size={16} className="mt-1 gold" />
                <span>
                  {settings?.address_line1}
                  {settings?.city && (
                    <>
                      <br />
                      {settings?.postal_code} {settings?.city}
                    </>
                  )}
                </span>
              </li>
            )}
          </ul>
        </div>

        <div>
          <div className="text-xs tracking-widest gold uppercase mb-4">
            Services
          </div>
          <ul className="space-y-2 text-sm text-gray-300">
            <li><Link to="/services/convoyage" className="hover:gold" data-testid="footer-link-convoyage">Convoyage de véhicule</Link></li>
            <li><Link to="/services/vtc" className="hover:gold" data-testid="footer-link-vtc">Trajet VTC</Link></li>
            <li><Link to="/services/nettoyage" className="hover:gold" data-testid="footer-link-nettoyage">Nettoyage automobile</Link></li>
            <li><Link to="/services/depannage" className="hover:gold" data-testid="footer-link-depannage">Dépannage (bientôt)</Link></li>
          </ul>
          <div className="mt-6 text-xs tracking-widest gold uppercase mb-3">Informations</div>
          <ul className="space-y-2 text-sm text-gray-300">
            <li><Link to="/a-propos" className="hover:gold" data-testid="footer-link-about">À propos</Link></li>
            <li><Link to="/faq" className="hover:gold" data-testid="footer-link-faq">FAQ</Link></li>
            <li><Link to="/suivi" className="hover:gold" data-testid="footer-link-track">Suivre ma réservation</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs tracking-widest gold uppercase mb-4">
            Scannez-nous
          </div>
          <QRCode
            data={typeof window !== "undefined" ? window.location.origin : "https://"}
            size={130}
            boxSize={8}
            label={null}
            testId="footer-qr"
          />
          <div className="text-[10px] text-gray-500 mt-3 max-w-[160px]">
            Retrouvez-nous en un scan, partout où vous êtes.
          </div>
        </div>
      </div>
      <div className="border-t border-white/5 py-6">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-500">
          <div>© {new Date().getFullYear()} {settings?.company_name || "DAS SIMAO AUTO"} — Tous droits réservés</div>
          <nav className="flex flex-wrap gap-x-4 gap-y-1 justify-center">
            <Link to="/mentions-legales" className="hover:gold" data-testid="footer-link-mentions">Mentions légales</Link>
            <span className="text-gray-700">·</span>
            <Link to="/cgv" className="hover:gold" data-testid="footer-link-cgv">CGV</Link>
            <span className="text-gray-700">·</span>
            <Link to="/confidentialite" className="hover:gold" data-testid="footer-link-confidentialite">Confidentialité</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
